﻿export const addressModel = {
	AddressType: null,
	Subpremise: null,
	Premise: null,
	Street: null,
	Suburb: null,
	State: null,
	Postcode: null,
	Country: null,
	FormattedAddress: null,
	GooglePlaceJson: null,
	Lat: null,
	Lng: null,
	PlaceId: null,
	GoogleMapsUrl: null
};

export const phoneNumberModel = {
	PhoneNumber: null,
	PhoneNumberType: "MOBILE"
};

export const emailAddressModel = {
	EmailAddress: null,
	EmailAddressType: "HOME"
};

export const contactModel = {
	Title: null,
	FirstName: null,
	Surname: null,

	EmailAddresses: null,
	PhoneNumbers: null,
	Addresses: null
};
